/**
 * @author alteredq / http://alteredqualia.com/
 */
import * as THREE from "../../../../libs/three.js/build/three.module.js";
import {Pass} from './ShaderPass'

class RenderPass extends Pass {

	constructor( overrideMaterial, clearColor, clearAlpha ) {

		super();

		/* this.scene = scene;
		this.camera = camera; */

		this.overrideMaterial = overrideMaterial;

		this.clearColor = clearColor;
		this.clearAlpha = ( clearAlpha !== undefined ) ? clearAlpha : 0;

		this.clear = true;
		this.clearDepth = false;
		this.needsSwap = false;
		this._oldClearColor = new THREE.Color();

	}

	render(scene, camera, viewports,renderer, writeBuffer, readBuffer /*, deltaTime, maskActive */ ) {

		const oldAutoClear = renderer.autoClear;
		renderer.autoClear = false;

		let oldClearAlpha, oldOverrideMaterial;

		if ( this.overrideMaterial !== undefined ) {

			oldOverrideMaterial = this.scene.overrideMaterial;

			 scene.overrideMaterial = this.overrideMaterial;

		}

		if ( this.clearColor ) {

			renderer.getClearColor( this._oldClearColor );
			oldClearAlpha = renderer.getClearAlpha();

			renderer.setClearColor( this.clearColor, this.clearAlpha );

		}

		if ( this.clearDepth ) {

			renderer.clearDepth();

		}


        let oldTarget = renderer.getRenderTarget();
		if(!this.renderToScreen)renderer.setRenderTarget( readBuffer );

		// TODO: Avoid using autoClear properties, see https://github.com/mrdoob/three.js/pull/15571#issuecomment-465669600
		if ( this.clear ) renderer.clear( renderer.autoClearColor, renderer.autoClearDepth, renderer.autoClearStencil );
		renderer.render( scene,  camera );


        if(!this.renderToScreen)renderer.setRenderTarget( oldTarget );


		if ( this.clearColor ) {

			renderer.setClearColor( this._oldClearColor, oldClearAlpha );

		}

		if ( this.overrideMaterial !== undefined ) {

			 scene.overrideMaterial = oldOverrideMaterial;

		}
        
        renderer.setRenderTarget(oldTarget);
        
		renderer.autoClear = oldAutoClear;

	}

}

 


export default RenderPass